module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [(_vm.active) ? _c('div', {
    staticClass: "info_modal"
  }, [_c('div', {
    staticClass: "info_modal_inner tan",
    style: (_vm.modalStyle)
  }, [_c('div', {
    staticClass: "row flush final_modal align_center"
  }, [_c('div', {
    staticClass: "span_8_xs offset_2_xs"
  }, [_vm._l((_vm.text[_vm.ind]), function(paragraph, index) {
    return _c('p', {
      key: index,
      staticClass: "modal_text"
    }, [_vm._v(_vm._s(paragraph))])
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.modalClose
    }
  }, [_vm._v("Proceed")])], 2)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c61ba20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/modal.vue
// module id = 561
// module chunks = 1